import { openModal, closeModal } from "./modal";

function forms(formSelector, modalTimerId) {

    // Forms

    const form = document.querySelector(formSelector);
    const phoneInput = document.querySelector('input[name="phone"]'),
          nameInput = document.querySelector('input[name="name"]'),
          checkbox = form.querySelector('input[name="consent_given"]'),
          maxLengthName = 50,
          maxPhoneDigits = 15;

    function validateForm(inp, pattern, maxLength) {
        inp.value = inp.value.replace(pattern, '');
        if (inp.value.length > maxLength) {
            inp.value = inp.value.slice(0, maxLength);
        }
    }

    nameInput.addEventListener('input', () => {
        validateForm(nameInput,/[^a-zA-Zа-яА-ЯёЁ\s]/g,maxLengthName);
    });



    phoneInput.addEventListener('input', () => {
        const hasLeadingPlus = phoneInput.value.startsWith('+');
        const digits = phoneInput.value
            .replace(/\D/g, '')
            .slice(0, maxPhoneDigits);

        phoneInput.value = `${hasLeadingPlus ? '+' : ''}${digits}`;
    });

    const message = {
        loading: 'image/form/spinner.svg',
        success: {
            type: 'success',
            title: 'Заявка отправлена',
            text: 'Спасибо! Мы получили ваши контакты. Логопед свяжется с вами в ближайшее время.'
        },
        failure: {
            type: 'failure',
            title: 'Не удалось подтвердить отправку',
            text: 'Попробуйте отправить заявку ещё раз. Если не получится, напишите по СМС своё имя и фразу "Я с сайта речистарт".'
        }
    };

    let isSubmitting = false;

    form.addEventListener('submit', (e) => {
        e.preventDefault();

        // Проверка домена (защита от зеркал)
        const validDomains = ['rechistart.ru', 'www.rechistart.ru', 'localhost', '127.0.0.1']; // только либо официальный рабочий домен или среды разработки
        if (!validDomains.includes(window.location.hostname)) {   // Защита от ботов
            return;
        }
        if (!checkbox.checked) {
            checkbox.reportValidity();
            return;
        }

        const formData = new FormData(form);
        // Honeypot (защита от ботов)
        if (formData.get('user_additional_info')) {
            return; // Бот заполнил скрытое поле (мы его скрываем при помощи display: none;)
        }

        if (isSubmitting) {
            return;
        }

        isSubmitting = true;

        const btn = form.querySelector('button[type="submit"]');
            btn.disabled = true; // Блокируем кнопку
            btn.style.opacity = '0.5'; 
            btn.style.cursor = 'not-allowed';

        const statusMessage = document.createElement('img');
            statusMessage.src = message.loading;
            statusMessage.classList.add('show');
            form.append(statusMessage);



        const response = Object.fromEntries(formData.entries());

            const pathname = window.location.pathname;
            let searchParams = new URLSearchParams(window.location.search);

            const isInfoArticleCta = searchParams.get('open_form') === 'true';
            const isAppBetaCta = searchParams.get('source') === 'app_beta';

            let site;
            let additionalInfo;
            let isClient = true;           
            let msgEmail;
            let referrer = document.referrer; 
            let sourceSite = 'Прямой заход / Неизвестно';

        if (pathname.includes('logoped-online') || pathname.includes('learning')) {
            site = 'Детская логопедия'
        } else {
            site = 'Взрослая логопедия'
        }

        if (isAppBetaCta) {
            additionalInfo = ':Заявка на бесплатный тестовый доступ к приложению «РечиСтарт» — переход из информационной статьи';
            isClient = false;
        } else if (isInfoArticleCta) {
            additionalInfo = ':Информационная статья - Нажал кнопку Пройти бесплатную диагностику';
        }  else {
            additionalInfo = ':Коммерческая страница';
        }

        // Внешние поисковые системы
        if (referrer.includes('google')) {
            sourceSite = 'Внешний: Google Search';
        } else if (referrer.includes('yandex')) {
            sourceSite = 'Внешний: Yandex Search';
        } 
        // Проверяем внутренние переходы (путешествия по сайту)
        else if (referrer.includes('rechistart.ru/blog/')) { 
            sourceSite = 'Внутренний: ИНФОРМАЦИОННАЯ СТАТЬЯ';
        }    
        // Проверяем другие внешние сайты (Соцсети, форумы)
        else if (referrer.length > 0 && !referrer.includes('rechistart.ru')) {
                try {
                    sourceSite = `Внешний: ${new URL(referrer).hostname}`;
                } catch {
                    sourceSite = 'Внешний: неизвестный источник';
                } 
        }

    msgEmail = `${isClient ? 'Клиент' : 'Желающий получить инструкцию по установке приложения'} из формы со страницы: ${site}
        ${additionalInfo}
        Источник: ${sourceSite}
        Имя: ${response.name}
        Телефон: ${response.phone}
        Реферер: ${referrer}`;

        const withTimeout = (promise, ms, label) => {
            return Promise.race([
                promise,
                new Promise((_, reject) => {
                    setTimeout(() => reject(new Error(`${label} timeout`)), ms);
                })
            ]);
        };

        const createRequestId = () => {
            if (window.crypto && typeof window.crypto.randomUUID === 'function') {
                return window.crypto.randomUUID();
            }

            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
                const random = Math.floor(Math.random() * 16);
                const value = char === 'x' ? random : (random & 0x3) | 0x8;

                return value.toString(16);
            });
        };

    const russianRequest = withTimeout(
        fetch('https://forms.rechistart.ru/api/lead.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                request_id: createRequestId(),
                lead_type: isAppBetaCta
                    ? 'app_instruction'
                    : 'site_client',
                service_area: site === 'Детская логопедия'
                    ? 'child_speech'
                    : 'adult_speech',
                name: response.name,
                phone: response.phone,
                page_path: pathname,
                referrer: referrer || null,
                consent_given: true,
                consent_version: '2026-08-20.1',
                user_additional_info:
                    formData.get('user_additional_info') || ''
            })
        })
        .then((res) => {
            if (!res.ok) {
                throw new Error(`Russian lead API failed: ${res.status}`);
            }

            return res.json();
        })
        .then((data) => {
            if (!data || data.ok !== true) {
                throw new Error('Russian lead API returned not ok');
            }

            return data;
        }),
            15000,
            'Russian lead API'
    );

    const sendExternalRequest = () => withTimeout(
        fetch('https://rechistart.ru/bridge.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                lead_type: isAppBetaCta
                    ? 'app_instruction'
                    : 'site_client',
                user_additional_info:
                    formData.get('user_additional_info') || ''
            })
        })
        .then((res) => {
            if (!res.ok) {
                throw new Error(`PHP bridge failed: ${res.status}`);
            }

            return res.json();
        })
        .then((data) => {
            if (!data || data.ok !== true) {
                throw new Error('PHP bridge returned not ok');
            }

            return data;
        }),
        15000,
        'External PHP bridge'
    );

    russianRequest
        .then(() => {
            form.reset();
            showResultModal(message.success);
            if (!isAppBetaCta) {
                try {
                    localStorage.setItem('isFormReceived', 'true');
                } catch (error) {
                    console.warn('Не удалось сохранить состояние формы', error);
                }
            }
            console.log('Russian request: fulfilled');

            // Запускаем уведомления в фоне после сохранения заявки.
            return sendExternalRequest()
                .then(() => {
                    console.log('External request: fulfilled');
                })
                .catch((error) => {
                    console.error('External request: rejected', error);
                });
        })
        .catch((error) => {
            console.error('Russian request: rejected', error);
            showResultModal(message.failure);
        })
        .finally(() => {
            isSubmitting = false;
            statusMessage.remove();
            btn.disabled = false;
            btn.style.opacity = '1';
            btn.style.cursor = 'pointer';
        });

    function showResultModal(result) {
        const modal = document.querySelector('.modal');
        const formDialog = modal.querySelector(
            '.modal__dialog:not(.modal__dialog_result)'
        );

        formDialog.classList.add('hide');

        const resultModal = document.createElement('div');

        resultModal.className =
            `modal__dialog modal__dialog_result modal__dialog_result_${result.type}`;

        const actions = result.type === 'success'
            ? `
                <button
                    type="button"
                    class="modal__result-primary"
                    data-close
                >
                    Вернуться на сайт
                </button>
            `
            : `
                <a
                    class="modal__result-primary modal__result-sms"
                    href="sms:+79281758320"
                >
                    Написать СМС логопеду
                </a>

                <span class="modal__result-phone">
                    Отправьте СМС на номер:<br>
                    +7 (928) 175-83-20
                </span>

                <button
                    type="button"
                    class="modal__result-secondary"
                    data-result-retry
                >
                    Вернуться к форме
                </button>
            `;

        resultModal.innerHTML = `
            <div class="modal__content modal__content_result">
                <button
                    type="button"
                    class="modal__type-button modal__close_result"
                    data-close
                >
                    Закрыть <span>&times;</span>
                </button>

                <div class="modal__title modal__title_result">
                    ${result.title}
                </div>

                <p class="modal__result-text">
                    ${result.text}
                </p>

                <div class="modal__result-actions">
                    ${actions}
                </div>
            </div>
        `;

        modal.append(resultModal);

        resultModal
            .querySelector('[data-result-retry]')
            ?.addEventListener('click', () => {
                resultModal.remove();
                formDialog.classList.remove('hide');
                nameInput.focus();
            });

        if (result.type === 'success') {
            setTimeout(() => {
                if (resultModal.isConnected) {
                    closeModal('.modal');
                }
            }, 7000);
        }
    }
});    
}

export default forms;